import { PEP_DESKTOP_APP_VERSION_FILTER_OPTIONS } from './pepDesktopAppVersion'
import styles from './PMSandBE.module.scss'

const PepDesktopAppVersionFilter = ({
  latestRelease,
  isLoadingLatestRelease,
  value,
  onChange
}) => {
  return (
    <div className={styles.pepDesktopAppFilterBar} aria-label="Desktop app version filter">
      <span className={styles.pepDesktopAppFilterTitle}>
        Desktop app
        {latestRelease ? (
          <span className={styles.pepDesktopAppFilterRelease}> (release {latestRelease})</span>
        ) : isLoadingLatestRelease ? (
          <span className={styles.pepDesktopAppFilterRelease}> (loading release…)</span>
        ) : null}
      </span>
      <div className={styles.pepDesktopAppFilterOptions} role="radiogroup">
        {PEP_DESKTOP_APP_VERSION_FILTER_OPTIONS.map(option => {
          const isActive = value === option.id
          return (
            <button
              key={option.id}
              type="button"
              role="radio"
              aria-checked={isActive}
              className={
                isActive
                  ? `${styles.pepDesktopAppFilterButton} ${styles.pepDesktopAppFilterButtonActive}`
                  : styles.pepDesktopAppFilterButton
              }
              onClick={() => onChange(option.id)}
            >
              {option.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default PepDesktopAppVersionFilter
